import {
  MaterialOrderPermissionsProvider,
  SilosContainer,
  StorageLevelsRouteProvider
} from '@features/storage-levels'
import {useUpmPlantContext} from '@hconnect/upm'
import React from 'react'

import {useStockMaterialOrderPermissions} from '../../shared/permissions/useStockMaterialOrderPermissions'

export const PageSilos: React.FC = () => {
  const {plantId: plantCode} = useUpmPlantContext()
  const permissions = useStockMaterialOrderPermissions()
  return (
    <StorageLevelsRouteProvider
      pathGenerators={{
        getStockPath: (subPath) => `/plants/${plantCode}/stock/${subPath}`,
        getMaterialsPath: () => `/plants/${plantCode}/stock/materials`,
        getSilosPath: () => `/plants/${plantCode}/stock/silos`
      }}
    >
      <MaterialOrderPermissionsProvider permissions={permissions}>
        <SilosContainer stockMaterialsOrdersUrl={`/plants/${plantCode}/stock/materials`} />
      </MaterialOrderPermissionsProvider>
    </StorageLevelsRouteProvider>
  )
}
